import { DefaultTemplate, COR, CORES_SIM_NAO } from './types';

// ============================================================
// VAREJO / SUPERMERCADO — chão de loja e gestão comercial
//
// O que difere do varejo em relação aos outros setores: o dinheiro está no
// detalhe operacional. Um item cadastrado com NCM errado vira passivo fiscal,
// uma ruptura de gôndola é venda perdida que ninguém registra, e a quebra
// costuma ser o segundo maior "fornecedor" de prejuízo depois do custo.
// A parte de estoque e distribuição está em ./supplyChain.ts.
// ============================================================

const cadastroProduto: DefaultTemplate = {
  id: 'tpl_cadastro_produto',
  name: 'Cadastro de Produto (Novo SKU)',
  descricao: 'Entrada de item novo no sortimento: análise comercial de margem e canibalização, acordo comercial com verba de entrada, cadastro fiscal (NCM, CEST, CST, MVA) e liberação para a gôndola. Item mal cadastrado vira passivo fiscal.',
  categoria: 'varejo',
  icone: '🏷️',
  etiquetas: [
    { nome: 'Marca Própria', cor: COR.roxo },
    { nome: 'Sazonal', cor: COR.amarelo },
    { nome: 'Fornecedor Novo', cor: COR.ciano },
    { nome: 'Perecível', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'cd_e1', nome: 'Sugestão do Item',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['cd_c1', 'cd_c2', 'cd_c6'],
      permiteMoverPara: ['cd_e2'],
      campos: [
        { id: 'cd_c1', nome: 'Descrição do Produto', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'cd_c2', nome: 'Fornecedor', tipo: 'texto', obrigatorio: true },
        { id: 'cd_c3', nome: 'Categoria / Seção', tipo: 'lista', obrigatorio: true, opcoes: ['Mercearia', 'Bebidas', 'Hortifruti', 'Açougue', 'Padaria', 'Frios e laticínios', 'Congelados', 'Limpeza', 'Higiene e beleza', 'Bazar / Utilidades', 'Pet', 'Eletro'] },
        { id: 'cd_c4', nome: 'Código de Barras (EAN)', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c5', nome: 'Custo de Aquisição', tipo: 'valor', obrigatorio: true },
        { id: 'cd_c6', nome: 'Preço de Venda Sugerido', tipo: 'valor', obrigatorio: false },
        { id: 'cd_c7', nome: 'Embalagem / Unidade de Compra', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c8', nome: 'Origem da Sugestão', tipo: 'lista', obrigatorio: false, opcoes: ['Fornecedor apresentou', 'Solicitação de cliente', 'Comprador prospectou', 'Reposição de item descontinuado', 'Tendência de mercado'] },
        { id: 'cd_c9', nome: 'Ficha Técnica / Foto', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'cd_e2', nome: 'Análise Comercial',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['cd_c1', 'cd_c11', 'cd_c14'],
      permiteMoverPara: ['cd_e3', 'cd_e6'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['cd_c14', 'cd_c15'],
      campos: [
        { id: 'cd_c10', nome: 'Já temos item similar?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cd_c11', nome: 'Margem Prevista (%)', tipo: 'numero', obrigatorio: false },
        { id: 'cd_c12', nome: 'Risco de Canibalização', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cd_c13', nome: 'Giro Estimado (un/mês)', tipo: 'numero', obrigatorio: false },
        { id: 'cd_c14', nome: 'Aprovado no sortimento?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cd_c15', nome: 'Parecer do Comprador', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cd_c16', nome: 'Lojas que vão receber', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Todas as lojas', 'Somente lojas grandes', 'Lojas de bairro', 'Loja piloto (teste)', 'E-commerce'] },
      ],
    },
    {
      id: 'cd_e3', nome: 'Acordo Comercial',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['cd_c1', 'cd_c17', 'cd_c21'],
      permiteMoverPara: ['cd_e4', 'cd_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'cd_c17', nome: 'Verba de Entrada', tipo: 'valor', obrigatorio: false },
        { id: 'cd_c18', nome: 'Bonificação Negociada', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c19', nome: 'Prazo de Pagamento', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c20', nome: 'Condições Especiais', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Troca garantida de vencidos', 'Reposição por promotor do fornecedor', 'Verba de encarte', 'Desconto por volume', 'Exclusividade', 'Frete CIF'] },
        { id: 'cd_c21', nome: 'Acordo fechado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cd_c22', nome: 'Acordo Assinado', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'cd_e4', nome: 'Cadastro Fiscal e Sistêmico',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['cd_c1', 'cd_c23', 'cd_c28'],
      permiteMoverPara: ['cd_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'cd_c23', nome: 'NCM', tipo: 'texto', obrigatorio: true },
        { id: 'cd_c24', nome: 'CEST', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c25', nome: 'CST / CSOSN', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c26', nome: 'Tem substituição tributária?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cd_c27', nome: 'MVA / Alíquota', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c28', nome: 'Cadastro concluído no ERP?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'cd_c29', nome: 'Código Interno Gerado', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c30', nome: 'Conferido por', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'cd_e5', nome: 'Ativo em Loja',
      camposVisiveisNoCard: ['cd_c1', 'cd_c29', 'cd_c31'],
      permiteCriarCards: false,
      campos: [
        { id: 'cd_c31', nome: 'Data de Entrada em Loja', tipo: 'data', obrigatorio: false },
        { id: 'cd_c32', nome: 'Posição no Planograma', tipo: 'texto', obrigatorio: false },
        { id: 'cd_c33', nome: 'Primeiro Pedido Colocado', tipo: 'valor', obrigatorio: false },
        { id: 'cd_c34', nome: 'Preço de Venda Praticado', tipo: 'valor', obrigatorio: false },
        { id: 'cd_c35', nome: 'Etiqueta de gôndola impressa?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'cd_e6', nome: 'Não Cadastrado',
      camposVisiveisNoCard: ['cd_c1', 'cd_c36'],
      permiteMoverPara: ['cd_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'cd_c36', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Margem insuficiente', 'Já temos similar', 'Acordo comercial não fechou', 'Sem espaço no planograma', 'Fornecedor sem condições fiscais', 'Giro estimado muito baixo'], coresOpcoes: { 'Margem insuficiente': COR.vermelho, 'Fornecedor sem condições fiscais': COR.vermelho } },
        { id: 'cd_c37', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'cd_c38', nome: 'Reavaliar em', tipo: 'data', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Aprovado no sortimento vai negociar',
      etapaOrigemId: 'cd_e2',
      condicao: { campoId: 'cd_c14', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cd_e3',
      etapaDestinoSenaoId: 'cd_e6',
    },
    {
      tipo: 'mover',
      nome: 'Acordo fechado libera o cadastro',
      etapaOrigemId: 'cd_e3',
      condicao: { campoId: 'cd_c21', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cd_e4',
      etapaDestinoSenaoId: 'cd_e6',
    },
    {
      tipo: 'mover',
      nome: 'Cadastro concluído ativa o item',
      etapaOrigemId: 'cd_e4',
      condicao: { campoId: 'cd_c28', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'cd_e5',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'MVA só quando tem substituição tributária',
      etapaOrigemId: 'cd_e4',
      condicao: { campoId: 'cd_c26', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['cd_c27'],
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Canibalização quando já existe similar',
      etapaOrigemId: 'cd_e2',
      condicao: { campoId: 'cd_c10', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['cd_c12'],
    },
  ],
  cards: [
    { id: 'cd_card1', titulo: 'Iogurte grego 500g - marca Vale', etapaId: 'cd_e3', etiquetas: ['Perecível'], valores: { cd_c1: 'Iogurte grego 500g - marca Vale', cd_c2: 'Laticínios Vale', cd_c3: 'Frios e laticínios', cd_c5: 8.9, cd_c6: 14.9, cd_c11: 40, cd_c17: 12000, cd_c13: 900 } },
    { id: 'cd_card2', titulo: 'Café torrado 500g - marca própria', etapaId: 'cd_e4', etiquetas: ['Marca Própria'], valores: { cd_c1: 'Café torrado 500g - marca própria', cd_c2: 'Torrefação Sul', cd_c3: 'Mercearia', cd_c5: 12.4, cd_c6: 19.9, cd_c11: 38, cd_c23: '0901.21.00', cd_c26: 'Sim', cd_c27: 'MVA 35% - ICMS-ST' } },
    { id: 'cd_card3', titulo: 'Energético lata 473ml', etapaId: 'cd_e2', etiquetas: ['Fornecedor Novo'], valores: { cd_c1: 'Energético lata 473ml', cd_c2: 'BebidasMax', cd_c3: 'Bebidas', cd_c5: 4.2, cd_c6: 7.99, cd_c10: 'Sim', cd_c12: 'Concorre direto com a marca líder que já tem 3 frentes na gôndola.' } },
    { id: 'cd_card4', titulo: 'Panetone 400g - linha natalina', etapaId: 'cd_e5', etiquetas: ['Sazonal'], valores: { cd_c1: 'Panetone 400g - linha natalina', cd_c2: 'Alimentos Vale', cd_c3: 'Mercearia', cd_c5: 11.5, cd_c29: '884412', cd_c34: 18.9, cd_c35: 'Sim' } },
    { id: 'cd_card5', titulo: 'Detergente concentrado 1L', etapaId: 'cd_e1', valores: { cd_c1: 'Detergente concentrado 1L', cd_c2: 'Química Brasil', cd_c3: 'Limpeza', cd_c5: 6.8, cd_c8: 'Fornecedor apresentou' } },
    { id: 'cd_card6', titulo: 'Azeite importado 500ml premium', etapaId: 'cd_e6', valores: { cd_c1: 'Azeite importado 500ml premium', cd_c2: 'Importadora Ibéria', cd_c3: 'Mercearia', cd_c5: 62, cd_c36: 'Giro estimado muito baixo', cd_c37: 'Perfil da praça não sustenta azeite acima de R$ 90 na gôndola.' } },
  ],
  tour: [
    '🏷️ Item novo com rito: margem analisada, acordo fechado e fiscal conferido antes de entrar na gôndola.',
    '1️⃣ "Sugestão": custo, EAN e ficha técnica do fornecedor.',
    '2️⃣ "Análise Comercial": margem, giro estimado e risco de canibalizar o que já vende.',
    '3️⃣ "Acordo Comercial": verba de entrada, bonificação e troca de vencidos negociadas antes do primeiro pedido.',
    '4️⃣ "Cadastro Fiscal": NCM, CEST e MVA — é aqui que nasce passivo fiscal quando é feito às pressas.',
    '5️⃣ "Ativo em Loja": planograma, preço praticado e etiqueta de gôndola.',
    '📌 O card do item reprovado guarda a data para reavaliar — fornecedor volta com proposta melhor.',
  ],
  etapasDicas: [
    { quemFaz: 'Comprador / Categoria', objetivo: 'Registrar a oportunidade com custo real, não com preço de tabela.' },
    { quemFaz: 'Gerente de Categoria', objetivo: 'Decidir por margem e giro, olhando o que o item tira de outro.', automacoes: ['Já configurado: reprovado guarda o motivo e a data de reavaliação'] },
    { quemFaz: 'Comprador', objetivo: 'Fechar verba de entrada e troca de vencidos por escrito.', conexoes: ['Ligue a "Perdas e Quebras" — troca garantida reduz quebra de perecível'] },
    { quemFaz: 'Fiscal / Cadastro', objetivo: 'Conferir NCM e ST; erro aqui só aparece na fiscalização.' },
    { quemFaz: 'Loja / Reposição', objetivo: 'Garantir espaço no planograma e etiqueta antes de abastecer.', conexoes: ['Ligue a "Ruptura e Reposição" para acompanhar o giro real'] },
    { quemFaz: 'Comprador', objetivo: 'Manter histórico do que foi recusado e por quê.' },
  ],
};

const perdasQuebras: DefaultTemplate = {
  id: 'tpl_perdas_quebras',
  name: 'Perdas e Quebras',
  descricao: 'Vencimento, avaria, quebra operacional e desvio registrados com valor, foto e responsável. Tem trilha para troca com fornecedor, baixa no sistema e investigação quando há suspeita de furto interno.',
  categoria: 'varejo',
  icone: '📉',
  etiquetas: [
    { nome: 'Suspeita de Desvio', cor: COR.vermelho },
    { nome: 'Troca com Fornecedor', cor: COR.verde },
    { nome: 'Reincidente', cor: COR.amarelo },
  ],
  etapas: [
    {
      id: 'pq_e1', nome: 'Registro da Perda',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['pq_c1', 'pq_c4', 'pq_c7'],
      permiteMoverPara: ['pq_e2'],
      campos: [
        { id: 'pq_c1', nome: 'Produto', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'pq_c2', nome: 'Loja / CD', tipo: 'texto', obrigatorio: true },
        { id: 'pq_c3', nome: 'Seção', tipo: 'lista', obrigatorio: false, opcoes: ['Mercearia', 'Bebidas', 'Hortifruti', 'Açougue', 'Padaria', 'Frios e laticínios', 'Congelados', 'Limpeza', 'Higiene e beleza', 'Bazar / Utilidades'] },
        { id: 'pq_c4', nome: 'Motivo da Perda', tipo: 'lista', obrigatorio: true, opcoes: ['Vencimento', 'Avaria no transporte', 'Avaria na loja', 'Quebra operacional', 'Falha de refrigeração', 'Furto externo', 'Suspeita de desvio interno', 'Erro de manipulação', 'Descarte sanitário'], coresOpcoes: { 'Suspeita de desvio interno': COR.vermelho, 'Furto externo': COR.vermelho, 'Falha de refrigeração': COR.amarelo, 'Vencimento': COR.amarelo } },
        { id: 'pq_c5', nome: 'Quantidade', tipo: 'numero', obrigatorio: true },
        { id: 'pq_c6', nome: 'Lote / Validade', tipo: 'texto', obrigatorio: false },
        { id: 'pq_c7', nome: 'Valor de Custo Perdido', tipo: 'valor', obrigatorio: true },
        { id: 'pq_c8', nome: 'Registrado por', tipo: 'texto', obrigatorio: false },
        { id: 'pq_c9', nome: 'Foto do Produto', tipo: 'anexo', obrigatorio: false },
        { id: 'pq_c10', nome: 'Descrição', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pq_e2', nome: 'Validação da Gerência',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['pq_c1', 'pq_c7', 'pq_c11'],
      permiteMoverPara: ['pq_e3', 'pq_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'pq_c11', nome: 'Perda confirmada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pq_c12', nome: 'Responsabilidade', tipo: 'lista', obrigatorio: false, opcoes: ['Fornecedor', 'Transportadora', 'Operação da loja', 'CD / logística', 'Cliente', 'Indeterminada'], coresOpcoes: { 'Fornecedor': COR.verde, 'Operação da loja': COR.amarelo, 'Indeterminada': COR.cinza } },
        { id: 'pq_c13', nome: 'Precisa de investigação?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pq_c14', nome: 'Observação da Gerência', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pq_e3', nome: 'Tratativa',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['pq_c1', 'pq_c15', 'pq_c17'],
      permiteMoverPara: ['pq_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'pq_c15', nome: 'Destino do Produto', tipo: 'lista', obrigatorio: true, opcoes: ['Troca com fornecedor', 'Devolução ao fornecedor', 'Descarte', 'Doação', 'Venda com desconto (liquida)', 'Uso interno / rotisseria'], coresOpcoes: { 'Troca com fornecedor': COR.verde, 'Descarte': COR.vermelho, 'Doação': COR.azul } },
        { id: 'pq_c16', nome: 'Fornecedor aceitou a troca?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pq_c17', nome: 'Valor Recuperado', tipo: 'valor', obrigatorio: false },
        { id: 'pq_c18', nome: 'Ação Preventiva', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pq_c19', nome: 'Comprovante da Tratativa', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pq_e4', nome: 'Baixa no Sistema',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['pq_c1', 'pq_c20', 'pq_c21'],
      permiteMoverPara: ['pq_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'pq_c20', nome: 'Documento da Baixa', tipo: 'texto', obrigatorio: false },
        { id: 'pq_c21', nome: 'Valor Baixado', tipo: 'valor', obrigatorio: false },
        { id: 'pq_c22', nome: 'Data da Baixa', tipo: 'data', obrigatorio: false },
        { id: 'pq_c23', nome: 'Baixa lançada?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pq_c24', nome: 'Responsável pelo Lançamento', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'pq_e5', nome: 'Encerrado',
      camposVisiveisNoCard: ['pq_c1', 'pq_c4', 'pq_c7'],
      permiteCriarCards: false,
      campos: [
        { id: 'pq_c25', nome: 'Data do Encerramento', tipo: 'data', obrigatorio: false },
        { id: 'pq_c26', nome: 'Perda Líquida', tipo: 'valor', obrigatorio: false },
        { id: 'pq_c27', nome: 'Gerou mudança de processo?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pq_c28', nome: 'Observação Final', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pq_e6', nome: 'Investigação',
      tempoMaximoHoras: 240,
      camposVisiveisNoCard: ['pq_c1', 'pq_c29', 'pq_c31'],
      permiteMoverPara: ['pq_e3', 'pq_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'pq_c29', nome: 'Tipo de Apuração', tipo: 'lista', obrigatorio: true, opcoes: ['Análise de câmeras', 'Conferência de estoque', 'Entrevista com equipe', 'Auditoria de caixa', 'Apuração com prevenção de perdas'] },
        { id: 'pq_c30', nome: 'Responsável pela Apuração', tipo: 'texto', obrigatorio: false },
        { id: 'pq_c31', nome: 'Conclusão', tipo: 'lista', obrigatorio: false, opcoes: ['Desvio confirmado', 'Erro operacional', 'Erro de sistema/cadastro', 'Sem conclusão'], coresOpcoes: { 'Desvio confirmado': COR.vermelho, 'Sem conclusão': COR.cinza } },
        { id: 'pq_c32', nome: 'Relatório da Apuração', tipo: 'anexo', obrigatorio: false },
        { id: 'pq_c33', nome: 'Medida Adotada', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Perda confirmada vai para tratativa',
      etapaOrigemId: 'pq_e2',
      condicao: { campoId: 'pq_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pq_e3',
      etapaDestinoSenaoId: 'pq_e5',
    },
    {
      tipo: 'mover',
      nome: 'Baixa lançada encerra o registro',
      etapaOrigemId: 'pq_e4',
      condicao: { campoId: 'pq_c23', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pq_e5',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Troca com fornecedor quando o destino é troca',
      etapaOrigemId: 'pq_e3',
      condicao: { campoId: 'pq_c15', operador: 'igual', valor: 'Troca com fornecedor' },
      camposAfetadosIds: ['pq_c16', 'pq_c17'],
    },
  ],
  cards: [
    { id: 'pq_card1', titulo: 'Iogurte grego 500g - 34 un vencidas', etapaId: 'pq_e3', etiquetas: ['Troca com Fornecedor', 'Reincidente'], valores: { pq_c1: 'Iogurte grego 500g - 34 un vencidas', pq_c2: '01 MATRIZ', pq_c3: 'Frios e laticínios', pq_c4: 'Vencimento', pq_c5: 34, pq_c7: 302.6, pq_c11: 'Sim', pq_c12: 'Fornecedor', pq_c15: 'Troca com fornecedor' } },
    { id: 'pq_card2', titulo: 'Carne bovina - falha no freezer 03', etapaId: 'pq_e2', valores: { pq_c1: 'Carne bovina - falha no freezer 03', pq_c2: '05 LONDRINA', pq_c3: 'Açougue', pq_c4: 'Falha de refrigeração', pq_c5: 48, pq_c7: 2840 } },
    { id: 'pq_card3', titulo: 'Whisky 1L - divergência de 12 un', etapaId: 'pq_e6', etiquetas: ['Suspeita de Desvio'], valores: { pq_c1: 'Whisky 1L - divergência de 12 un', pq_c2: '11 VILA VELHA', pq_c3: 'Bebidas', pq_c4: 'Suspeita de desvio interno', pq_c5: 12, pq_c7: 1188, pq_c29: 'Análise de câmeras' } },
    { id: 'pq_card4', titulo: 'Hortifruti - descarte semanal', etapaId: 'pq_e4', valores: { pq_c1: 'Hortifruti - descarte semanal', pq_c2: '07 CD SC', pq_c3: 'Hortifruti', pq_c4: 'Descarte sanitário', pq_c5: 120, pq_c7: 640, pq_c15: 'Descarte', pq_c21: 640 } },
    { id: 'pq_card5', titulo: 'Caixa de sabão em pó avariada', etapaId: 'pq_e1', valores: { pq_c1: 'Caixa de sabão em pó avariada', pq_c2: '01 MATRIZ', pq_c3: 'Limpeza', pq_c4: 'Avaria no transporte', pq_c5: 18, pq_c7: 396 } },
    { id: 'pq_card6', titulo: 'Pães do dia anterior - doação', etapaId: 'pq_e5', valores: { pq_c1: 'Pães do dia anterior - doação', pq_c2: '01 MATRIZ', pq_c3: 'Padaria', pq_c4: 'Vencimento', pq_c5: 60, pq_c7: 180, pq_c26: 180, pq_c27: 'Sim' } },
  ],
  tour: [
    '📉 Quebra medida deixa de ser aceita como fatalidade — ela ganha valor, causa e responsável.',
    '1️⃣ "Registro": produto, motivo, quantidade e valor de custo perdido.',
    '2️⃣ "Validação da Gerência": de quem é a responsabilidade — fornecedor, transporte ou operação.',
    '3️⃣ "Tratativa": troca com fornecedor recupera dinheiro; descarte é perda pura.',
    '4️⃣ "Baixa no Sistema": documento e valor lançados.',
    '🔍 "Investigação": trilha separada para suspeita de desvio, com câmeras e apuração.',
    '📊 Filtre por seção e motivo para achar onde a quebra concentra — normalmente perecível e refrigeração.',
  ],
  etapasDicas: [
    { quemFaz: 'Repositor / Encarregado de seção', objetivo: 'Registrar na hora, com foto e valor.' },
    { quemFaz: 'Gerente de loja', objetivo: 'Definir responsabilidade — é o que permite cobrar fornecedor.' },
    { quemFaz: 'Comprador / Encarregado', objetivo: 'Buscar troca antes de descartar.', conexoes: ['Ligue a "Cadastro de Produto" — troca garantida deve estar no acordo comercial'] },
    { quemFaz: 'Fiscal de estoque', objetivo: 'Baixar com documento; estoque errado gera ruptura depois.' },
    { quemFaz: 'Gerente / Controladoria', objetivo: 'Transformar perda recorrente em mudança de processo.' },
    { quemFaz: 'Prevenção de Perdas', objetivo: 'Apurar com método, sem acusação sem prova.' },
  ],
};

const encartesPromocoes: DefaultTemplate = {
  id: 'tpl_encartes_promocoes',
  name: 'Encartes e Promoções',
  descricao: 'Tabloide do começo ao fim: seleção de itens, negociação de verba com fornecedor, aprovação da margem do encarte, arte e prova gráfica, execução na loja e apuração de sell-out. Promoção sem apuração é desconto sem retorno.',
  categoria: 'varejo',
  icone: '📰',
  etiquetas: [
    { nome: 'Data Comemorativa', cor: COR.roxo },
    { nome: 'Verba de Fornecedor', cor: COR.verde },
    { nome: 'Item Isca', cor: COR.vermelho },
  ],
  etapas: [
    {
      id: 'en_e1', nome: 'Planejamento',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['en_c1', 'en_c3', 'en_c4'],
      permiteMoverPara: ['en_e2'],
      campos: [
        { id: 'en_c1', nome: 'Nome do Encarte / Ação', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'en_c2', nome: 'Tipo de Ação', tipo: 'lista', obrigatorio: true, opcoes: ['Encarte semanal', 'Encarte quinzenal', 'Data comemorativa', 'Aniversário da loja', 'Liquidação', 'Ação de ponta de gôndola', 'Clube de descontos', 'Leve mais pague menos'], coresOpcoes: { 'Data comemorativa': COR.roxo, 'Liquidação': COR.amarelo } },
        { id: 'en_c3', nome: 'Período de Vigência', tipo: 'texto', obrigatorio: true },
        { id: 'en_c4', nome: 'Data de Início', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'en_c5', nome: 'Lojas Participantes', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Todas as lojas', 'Somente lojas grandes', 'Lojas de bairro', 'E-commerce', 'Atacado'] },
        { id: 'en_c6', nome: 'Nº de Itens Previstos', tipo: 'numero', obrigatorio: false },
        { id: 'en_c7', nome: 'Objetivo da Ação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'en_e2', nome: 'Negociação com Fornecedores',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['en_c1', 'en_c8', 'en_c11'],
      permiteMoverPara: ['en_e3', 'en_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'en_c8', nome: 'Verba Negociada', tipo: 'valor', obrigatorio: false },
        { id: 'en_c9', nome: 'Itens Negociados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'en_c10', nome: 'Volume Comprometido', tipo: 'texto', obrigatorio: false },
        { id: 'en_c11', nome: 'Estoque garantido para a ação?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'en_c12', nome: 'Acordos Assinados', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'en_e3', nome: 'Aprovação Comercial',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['en_c1', 'en_c13', 'en_c15'],
      permiteMoverPara: ['en_e4', 'en_e7'],
      permiteCriarCards: false,
      limparCamposAoRetornar: ['en_c15', 'en_c16'],
      campos: [
        { id: 'en_c13', nome: 'Margem Média do Encarte (%)', tipo: 'numero', obrigatorio: false },
        { id: 'en_c14', nome: 'Investimento Total', tipo: 'valor', obrigatorio: false },
        { id: 'en_c15', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'en_c16', nome: 'Ajustes Solicitados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'en_c17', nome: 'Planilha de Itens e Preços', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'en_e4', nome: 'Arte e Produção',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['en_c1', 'en_c18', 'en_c20'],
      permiteMoverPara: ['en_e5'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'en_c18', nome: 'Progresso da Arte', tipo: 'progresso', obrigatorio: false },
        { id: 'en_c19', nome: 'Materiais', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Tabloide impresso', 'Cartazes de gôndola', 'Post redes sociais', 'WhatsApp / lista', 'Rádio interno', 'Banner do site', 'Faixa de fachada'] },
        { id: 'en_c20', nome: 'Arte aprovada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'en_c21', nome: 'Preços conferidos na arte?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'en_c22', nome: 'Arquivo Final', tipo: 'anexo', obrigatorio: false },
        { id: 'en_c23', nome: 'Gráfica / Fornecedor', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'en_e5', nome: 'Execução na Loja',
      camposVisiveisNoCard: ['en_c1', 'en_c24', 'en_c26'],
      permiteMoverPara: ['en_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'en_c24', nome: 'Checklist de Loja', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Preços alterados no sistema', 'Cartazes afixados', 'Ponta de gôndola montada', 'Estoque abastecido', 'Equipe orientada', 'Tabloide distribuído'] },
        { id: 'en_c25', nome: 'Data de Início Real', tipo: 'data', obrigatorio: false },
        { id: 'en_c26', nome: 'Houve ruptura durante a ação?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'en_c27', nome: 'Itens em Ruptura', tipo: 'texto_longo', obrigatorio: false },
        { id: 'en_c28', nome: 'Fotos da Execução', tipo: 'anexo', obrigatorio: false },
        { id: 'en_c29', nome: 'Ação encerrada?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'en_e6', nome: 'Apuração de Resultado',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['en_c1', 'en_c30', 'en_c33'],
      permiteCriarCards: false,
      campos: [
        { id: 'en_c30', nome: 'Venda no Período', tipo: 'valor', obrigatorio: false },
        { id: 'en_c31', nome: 'Venda dos Itens do Encarte', tipo: 'valor', obrigatorio: false },
        { id: 'en_c32', nome: 'Crescimento vs Período Anterior (%)', tipo: 'numero', obrigatorio: false },
        { id: 'en_c33', nome: 'Margem Realizada (%)', tipo: 'numero', obrigatorio: false },
        { id: 'en_c34', nome: 'Verba Recebida do Fornecedor', tipo: 'valor', obrigatorio: false },
        { id: 'en_c35', nome: 'Atingiu o objetivo?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Parcialmente', 'Não'], coresOpcoes: { 'Sim': COR.verde, 'Parcialmente': COR.amarelo, 'Não': COR.vermelho } },
        { id: 'en_c36', nome: 'Aprendizados', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'en_e7', nome: 'Cancelada',
      camposVisiveisNoCard: ['en_c1', 'en_c37'],
      permiteMoverPara: ['en_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'en_c37', nome: 'Motivo', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Com estoque garantido vai para aprovação',
      etapaOrigemId: 'en_e2',
      condicao: { campoId: 'en_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'en_e3',
    },
    {
      tipo: 'mover',
      nome: 'Aprovado libera a arte',
      etapaOrigemId: 'en_e3',
      condicao: { campoId: 'en_c15', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'en_e4',
      etapaDestinoSenaoId: 'en_e7',
    },
    {
      tipo: 'mover',
      nome: 'Arte aprovada vai para a loja',
      etapaOrigemId: 'en_e4',
      condicao: { campoId: 'en_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'en_e5',
    },
    {
      tipo: 'mover',
      nome: 'Ação encerrada abre a apuração',
      etapaOrigemId: 'en_e5',
      condicao: { campoId: 'en_c29', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'en_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Itens em ruptura quando houver',
      etapaOrigemId: 'en_e5',
      condicao: { campoId: 'en_c26', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['en_c27'],
    },
  ],
  cards: [
    { id: 'en_card1', titulo: 'Tabloide Semana do Consumidor', etapaId: 'en_e4', etiquetas: ['Data Comemorativa', 'Verba de Fornecedor'], valores: { en_c1: 'Tabloide Semana do Consumidor', en_c2: 'Data comemorativa', en_c3: '10 a 17 de março', en_c6: 84, en_c8: 96000, en_c13: 21, en_c18: 70 } },
    { id: 'en_card2', titulo: 'Encarte semanal - 3ª semana de agosto', etapaId: 'en_e5', valores: { en_c1: 'Encarte semanal - 3ª semana de agosto', en_c2: 'Encarte semanal', en_c3: '18 a 24 de agosto', en_c6: 62, en_c8: 34000, en_c26: 'Sim', en_c27: 'Óleo de soja e café 500g esgotaram no segundo dia.' } },
    { id: 'en_card3', titulo: 'Aniversário 20 anos - Loja Matriz', etapaId: 'en_e6', etiquetas: ['Item Isca'], valores: { en_c1: 'Aniversário 20 anos - Loja Matriz', en_c2: 'Aniversário da loja', en_c3: '01 a 10 de julho', en_c30: 1840000, en_c32: 34, en_c33: 18, en_c34: 120000, en_c35: 'Sim' } },
    { id: 'en_card4', titulo: 'Ação Festa Junina - hortifruti e bebidas', etapaId: 'en_e2', etiquetas: ['Data Comemorativa'], valores: { en_c1: 'Ação Festa Junina - hortifruti e bebidas', en_c2: 'Data comemorativa', en_c3: '01 a 30 de junho', en_c6: 40 } },
    { id: 'en_card5', titulo: 'Liquidação de bazar - troca de coleção', etapaId: 'en_e3', valores: { en_c1: 'Liquidação de bazar - troca de coleção', en_c2: 'Liquidação', en_c3: '05 a 20 de setembro', en_c13: 9, en_c14: 42000 } },
    { id: 'en_card6', titulo: 'Clube de descontos - lançamento', etapaId: 'en_e1', valores: { en_c1: 'Clube de descontos - lançamento', en_c2: 'Clube de descontos', en_c3: 'Contínuo a partir de outubro' } },
    { id: 'en_card7', titulo: 'Ação Black Friday - eletro', etapaId: 'en_e7', valores: { en_c1: 'Ação Black Friday - eletro', en_c2: 'Data comemorativa', en_c3: 'Novembro', en_c37: 'Fornecedor não garantiu estoque no volume necessário. Adiada para dezembro.' } },
  ],
  tour: [
    '📰 Encarte com resultado apurado, não só desconto dado.',
    '1️⃣ "Planejamento": período, lojas e objetivo da ação.',
    '2️⃣ "Negociação": verba do fornecedor e a pergunta que salva o encarte — tem estoque garantido?',
    '3️⃣ "Aprovação Comercial": margem média do encarte na mesa antes de imprimir.',
    '4️⃣ "Arte e Produção": checklist de materiais e conferência de preço na arte.',
    '5️⃣ "Execução na Loja": preço no sistema, cartaz na gôndola e estoque abastecido.',
    '📊 "Apuração": venda, crescimento, margem realizada e verba efetivamente recebida.',
  ],
  etapasDicas: [
    { quemFaz: 'Comercial / Marketing', objetivo: 'Planejar com antecedência — encarte às pressas custa margem.' },
    { quemFaz: 'Compradores', objetivo: 'Negociar verba e travar estoque antes de anunciar.', automacoes: ['Já configurado: só avança com estoque garantido'] },
    { quemFaz: 'Gerente Comercial', objetivo: 'Aprovar olhando a margem do conjunto, não item a item.' },
    { quemFaz: 'Marketing / Designer', objetivo: 'Conferir preço na arte — erro de preço no tabloide é obrigação de cumprir.' },
    { quemFaz: 'Gerentes de loja', objetivo: 'Garantir preço no sistema e cartaz na gôndola no dia certo.', conexoes: ['Ligue a "Ruptura e Reposição" durante a ação'] },
    { quemFaz: 'Comercial / Controladoria', objetivo: 'Apurar e cobrar a verba do fornecedor.' },
    { quemFaz: 'Comercial', objetivo: 'Registrar por que a ação não aconteceu.' },
  ],
};

const rupturaGondola: DefaultTemplate = {
  id: 'tpl_ruptura_gondola',
  name: 'Ruptura e Reposição de Gôndola',
  descricao: 'Produto faltando na prateleira vira card com diagnóstico da causa: estoque virtual, falha de reposição, atraso do CD ou do fornecedor. Mede a venda perdida e escala quando a ruptura persiste.',
  categoria: 'varejo',
  icone: '🛒',
  etiquetas: [
    { nome: 'Item de Encarte', cor: COR.vermelho },
    { nome: 'Estoque Virtual', cor: COR.amarelo },
    { nome: 'Curva A', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'rg_e1', nome: 'Ruptura Identificada',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['rg_c1', 'rg_c2', 'rg_c6'],
      permiteMoverPara: ['rg_e2'],
      campos: [
        { id: 'rg_c1', nome: 'Produto', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'rg_c2', nome: 'Loja', tipo: 'texto', obrigatorio: true },
        { id: 'rg_c3', nome: 'Seção', tipo: 'lista', obrigatorio: false, opcoes: ['Mercearia', 'Bebidas', 'Hortifruti', 'Açougue', 'Padaria', 'Frios e laticínios', 'Congelados', 'Limpeza', 'Higiene e beleza', 'Bazar / Utilidades'] },
        { id: 'rg_c4', nome: 'Estoque no Sistema', tipo: 'numero', obrigatorio: false },
        { id: 'rg_c5', nome: 'Estoque Físico Contado', tipo: 'numero', obrigatorio: false },
        { id: 'rg_c6', nome: 'Curva do Item', tipo: 'lista', obrigatorio: false, opcoes: ['A', 'B', 'C'], coresOpcoes: { 'A': COR.roxo, 'B': COR.azul, 'C': COR.cinza } },
        { id: 'rg_c7', nome: 'Item está em encarte?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'rg_c8', nome: 'Identificado por', tipo: 'texto', obrigatorio: false },
        { id: 'rg_c9', nome: 'Foto da Gôndola', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'rg_e2', nome: 'Diagnóstico da Causa',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['rg_c1', 'rg_c10', 'rg_c12'],
      permiteMoverPara: ['rg_e3', 'rg_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'rg_c10', nome: 'Causa', tipo: 'lista', obrigatorio: true, opcoes: ['Estoque virtual (sistema x físico)', 'Falha de reposição na loja', 'Produto parado no depósito', 'Atraso do CD', 'Atraso do fornecedor', 'Ponto de pedido mal parametrizado', 'Venda acima do previsto', 'Item bloqueado no cadastro'], coresOpcoes: { 'Estoque virtual (sistema x físico)': COR.amarelo, 'Atraso do fornecedor': COR.vermelho, 'Item bloqueado no cadastro': COR.vermelho } },
        { id: 'rg_c11', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: false },
        { id: 'rg_c12', nome: 'Venda Perdida Estimada', tipo: 'valor', obrigatorio: false },
        { id: 'rg_c13', nome: 'Dias em Ruptura', tipo: 'numero', obrigatorio: false },
        { id: 'rg_c14', nome: 'Tem solução na loja?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'rg_e3', nome: 'Ação de Reposição',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['rg_c1', 'rg_c15', 'rg_c17'],
      permiteMoverPara: ['rg_e4', 'rg_e5'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'rg_c15', nome: 'Ação Tomada', tipo: 'lista', obrigatorio: true, opcoes: ['Reposição do depósito da loja', 'Transferência entre lojas', 'Pedido urgente ao CD', 'Compra emergencial local', 'Ajuste de estoque no sistema', 'Correção do ponto de pedido', 'Desbloqueio do cadastro'], coresOpcoes: { 'Compra emergencial local': COR.amarelo, 'Ajuste de estoque no sistema': COR.azul } },
        { id: 'rg_c16', nome: 'Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'rg_c17', nome: 'Prazo da Reposição', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'rg_c18', nome: 'Gôndola reposta?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'rg_c19', nome: 'Observação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'rg_e4', nome: 'Resolvida',
      camposVisiveisNoCard: ['rg_c1', 'rg_c2', 'rg_c20'],
      permiteCriarCards: false,
      campos: [
        { id: 'rg_c20', nome: 'Data da Reposição', tipo: 'data', obrigatorio: false },
        { id: 'rg_c21', nome: 'Tempo Total de Ruptura (horas)', tipo: 'numero', obrigatorio: false },
        { id: 'rg_c22', nome: 'Gerou ação preventiva?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'rg_c23', nome: 'Ação Preventiva', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'rg_e5', nome: 'Escalada para Compras',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['rg_c1', 'rg_c24', 'rg_c26'],
      permiteMoverPara: ['rg_e3', 'rg_e4'],
      permiteCriarCards: false,
      ordenacaoCards: 'vencimento_proximo',
      campos: [
        { id: 'rg_c24', nome: 'Comprador Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'rg_c25', nome: 'Situação do Fornecimento', tipo: 'lista', obrigatorio: false, opcoes: ['Pedido em aberto', 'Fornecedor sem estoque', 'Produto descontinuado', 'Bloqueio financeiro com fornecedor', 'Buscando fornecedor alternativo'], coresOpcoes: { 'Produto descontinuado': COR.cinza, 'Bloqueio financeiro com fornecedor': COR.vermelho } },
        { id: 'rg_c26', nome: 'Previsão de Normalização', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'rg_c27', nome: 'Providência de Compras', tipo: 'texto_longo', obrigatorio: false },
        { id: 'rg_c28', nome: 'Precisa substituir o item?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Com solução na loja vai para reposição',
      etapaOrigemId: 'rg_e2',
      condicao: { campoId: 'rg_c14', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'rg_e3',
      etapaDestinoSenaoId: 'rg_e5',
    },
    {
      tipo: 'mover',
      nome: 'Gôndola reposta resolve o card',
      etapaOrigemId: 'rg_e3',
      condicao: { campoId: 'rg_c18', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'rg_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Ação preventiva quando houver',
      etapaOrigemId: 'rg_e4',
      condicao: { campoId: 'rg_c22', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['rg_c23'],
    },
  ],
  cards: [
    { id: 'rg_card1', titulo: 'Óleo de soja 900ml - Matriz', etapaId: 'rg_e5', etiquetas: ['Item de Encarte', 'Curva A'], valores: { rg_c1: 'Óleo de soja 900ml - Matriz', rg_c2: '01 MATRIZ', rg_c3: 'Mercearia', rg_c6: 'A', rg_c7: 'Sim', rg_c10: 'Atraso do fornecedor', rg_c12: 8400, rg_c13: 3, rg_c25: 'Fornecedor sem estoque' } },
    { id: 'rg_card2', titulo: 'Leite integral 1L - Londrina', etapaId: 'rg_e3', etiquetas: ['Curva A'], valores: { rg_c1: 'Leite integral 1L - Londrina', rg_c2: '05 LONDRINA', rg_c3: 'Frios e laticínios', rg_c4: 240, rg_c5: 0, rg_c6: 'A', rg_c10: 'Estoque virtual (sistema x físico)', rg_c15: 'Ajuste de estoque no sistema' } },
    { id: 'rg_card3', titulo: 'Papel higiênico 12 rolos - Vila Velha', etapaId: 'rg_e2', valores: { rg_c1: 'Papel higiênico 12 rolos - Vila Velha', rg_c2: '11 VILA VELHA', rg_c3: 'Higiene e beleza', rg_c4: 180, rg_c5: 180, rg_c6: 'A', rg_c10: 'Produto parado no depósito' } },
    { id: 'rg_card4', titulo: 'Café 500g - CD SC', etapaId: 'rg_e4', etiquetas: ['Item de Encarte'], valores: { rg_c1: 'Café 500g - CD SC', rg_c2: '07 CD SC', rg_c6: 'A', rg_c7: 'Sim', rg_c21: 26, rg_c22: 'Sim', rg_c23: 'Ponto de pedido elevado de 40 para 120 caixas durante encartes.' } },
    { id: 'rg_card5', titulo: 'Sabão em pó 1,6kg - Matriz', etapaId: 'rg_e1', etiquetas: ['Estoque Virtual'], valores: { rg_c1: 'Sabão em pó 1,6kg - Matriz', rg_c2: '01 MATRIZ', rg_c3: 'Limpeza', rg_c4: 96, rg_c5: 0, rg_c6: 'B' } },
    { id: 'rg_card6', titulo: 'Refrigerante 2L - loja de bairro', etapaId: 'rg_e3', valores: { rg_c1: 'Refrigerante 2L - loja de bairro', rg_c2: '24 CD GO', rg_c3: 'Bebidas', rg_c6: 'A', rg_c10: 'Falha de reposição na loja', rg_c15: 'Reposição do depósito da loja' } },
  ],
  tour: [
    '🛒 Ruptura é venda perdida que ninguém contabiliza. Aqui ela vira card com valor.',
    '1️⃣ "Ruptura Identificada": estoque do sistema x contado — a diferença já denuncia estoque virtual.',
    '2️⃣ "Diagnóstico": a causa muda tudo. Falha de reposição resolve na loja; atraso de fornecedor não.',
    '3️⃣ "Ação de Reposição": transferência entre lojas, pedido urgente ao CD ou ajuste de estoque.',
    '4️⃣ "Resolvida": tempo total de ruptura medido em horas.',
    '⬆️ "Escalada para Compras": quando a loja não resolve sozinha, o comprador assume com prazo.',
    '📊 Filtre por causa para atacar a raiz — normalmente é ponto de pedido mal parametrizado.',
  ],
  etapasDicas: [
    { quemFaz: 'Repositor / Encarregado', objetivo: 'Registrar contando o físico, não só olhando o sistema.' },
    { quemFaz: 'Encarregado de seção', objetivo: 'Diagnosticar a causa real — sem isso a ruptura volta na semana seguinte.', automacoes: ['Já configurado: sem solução na loja escala para compras'] },
    { quemFaz: 'Repositor / Estoquista', objetivo: 'Repor e registrar o tempo que a gôndola ficou vazia.' },
    { quemFaz: 'Encarregado', objetivo: 'Transformar ruptura recorrente em correção de parâmetro.' },
    { quemFaz: 'Comprador', objetivo: 'Assumir o item quando o problema é fornecimento.', conexoes: ['Ligue a "Reposição e Planejamento de Compras" para corrigir o ponto de pedido'] },
  ],
};

export const TEMPLATES_VAREJO: DefaultTemplate[] = [
  cadastroProduto,
  perdasQuebras,
  encartesPromocoes,
  rupturaGondola,
];
